import React, { useState, useEffect } from 'react';

const TeacherFormModal = ({
  isFormOpen,
  closeForm,
  currentTeacher,
  formData,
  setFormData,
  handleSubmit,
  companies,
  lessonGroups,
  handleDersCheckboxChange,
  formError,
  isLoading
}) => {
  const [lessonSearchTerm, setLessonSearchTerm] = useState('');

  useEffect(() => {
    if (!isFormOpen) setLessonSearchTerm('');
  }, [isFormOpen]);

  if (!isFormOpen) return null;

  const getPasswordError = () => {
    if (!currentTeacher && (!formData.password || formData.password.trim() === '')) {
      return 'Yeni öğretmen için şifre zorunludur';
    }
    if (formData.password && formData.password.length > 0 && formData.password.length < 6) {
      return 'Şifre en az 6 karakter olmalıdır';
    }
    return '';
  };

  const passwordError = getPasswordError();

  const filteredLessonGroups = lessonGroups.filter(group =>
    group.ders_adi.toLowerCase().includes(lessonSearchTerm.toLowerCase())
  );

  const inputClass = "w-full bg-white border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-gray-400 focus:border-gray-400 transition-colors disabled:bg-gray-50 disabled:text-gray-400";
  const labelClass = "block mb-1.5 text-xs font-medium text-gray-600";

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center p-3 sm:p-4 z-50">
      <div className="bg-white rounded-lg w-full max-w-3xl max-h-[95vh] flex flex-col overflow-hidden border border-gray-200">
        {/* Header */}
        <div className="flex justify-between items-center px-5 py-3 border-b border-gray-200">
          <h3 className="text-base font-semibold text-gray-900">
            {currentTeacher ? 'Öğretmeni Düzenle' : 'Yeni Öğretmen'}
          </h3>
          <button
            onClick={closeForm}
            className="p-1.5 rounded-md text-gray-400 hover:text-gray-900 hover:bg-gray-100 transition-colors"
            disabled={isLoading}
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Error */}
        {formError && (
          <div className="mx-5 mt-3 px-3 py-2 bg-red-50 border border-red-200 rounded-md text-sm text-red-700">
            {formError}
          </div>
        )}

        {/* Body */}
        <div className="flex-1 overflow-y-auto">
          <form onSubmit={handleSubmit} id="teacher-form" className="p-5">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div>
                <label htmlFor="formAdi" className={labelClass}>
                  Ad Soyad <span className="text-red-500">*</span>
                </label>
                <input
                  id="formAdi"
                  name="adi"
                  type="text"
                  className={inputClass}
                  value={formData.adi}
                  onChange={(e) => setFormData({ ...formData, adi: e.target.value })}
                  placeholder="Öğretmenin adı ve soyadı"
                  required
                  disabled={isLoading}
                />
              </div>

              <div>
                <label htmlFor="formTelefon" className={labelClass}>Telefon</label>
                <input
                  id="formTelefon"
                  name="telefon"
                  type="tel"
                  className={inputClass}
                  value={formData.telefon}
                  onChange={(e) => setFormData({ ...formData, telefon: e.target.value })}
                  placeholder="0555 123 45 67"
                  disabled={isLoading}
                />
              </div>

              <div>
                <label htmlFor="formTeltwo" className={labelClass}>Telefon (2.)</label>
                <input
                  id="formTeltwo"
                  name="teltwo"
                  type="tel"
                  className={inputClass}
                  value={formData.teltwo}
                  onChange={(e) => setFormData({ ...formData, teltwo: e.target.value })}
                  placeholder="0555 987 65 43"
                  disabled={isLoading}
                />
              </div>

              <div>
                <label htmlFor="formEposta" className={labelClass}>
                  E-Posta {!currentTeacher && <span className="text-red-500">*</span>}
                </label>
                <input
                  id="formEposta"
                  name="e_posta"
                  type="email"
                  className={inputClass}
                  value={formData.e_posta}
                  onChange={(e) => setFormData({ ...formData, e_posta: e.target.value })}
                  placeholder="ornek@email.com"
                  required={!currentTeacher}
                  disabled={isLoading}
                />
              </div>

              <div>
                <label htmlFor="formIban" className={labelClass}>IBAN</label>
                <input
                  id="formIban"
                  name="iban"
                  className={inputClass}
                  value={formData.iban}
                  onChange={(e) => setFormData({ ...formData, iban: e.target.value })}
                  placeholder="TR00 0000 0000 0000 0000 0000 00"
                  disabled={isLoading}
                />
              </div>

              <div>
                <label htmlFor="formSistem" className={labelClass}>Şirket</label>
                <select
                  id="formSistem"
                  name="sistem"
                  className={inputClass}
                  value={formData.sistem}
                  onChange={(e) => setFormData({ ...formData, sistem: e.target.value })}
                  disabled={isLoading}
                >
                  <option value="">Şirket seçiniz</option>
                  {companies.map(company => (
                    <option key={company.id} value={company.id}>{company.sirket_adi}</option>
                  ))}
                </select>
              </div>

              <div>
                <label htmlFor="formStatus" className={labelClass}>Durum</label>
                <select
                  id="formStatus"
                  name="status"
                  className={inputClass}
                  value={formData.status}
                  onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                  disabled={isLoading}
                >
                  <option value="">Seçiniz</option>
                  <option value="aktif">Aktif</option>
                  <option value="pasif">Pasif</option>
                  <option value="beklemede">Beklemede</option>
                </select>
              </div>

              <div>
                <label htmlFor="formPassword" className={labelClass}>
                  Şifre {!currentTeacher && <span className="text-red-500">*</span>}
                  {currentTeacher && <span className="text-gray-400 ml-1">(boş bırak = değişmez)</span>}
                </label>
                <input
                  id="formPassword"
                  name="password"
                  type="password"
                  autoComplete="new-password"
                  className={`${inputClass} ${passwordError ? 'border-red-300' : ''}`}
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                  placeholder="••••••••"
                  required={!currentTeacher}
                  disabled={isLoading}
                />
                {passwordError && (
                  <p className="mt-1 text-xs text-red-600">{passwordError}</p>
                )}
              </div>

              <div className="lg:col-span-2">
                <label htmlFor="formAdres" className={labelClass}>Adres</label>
                <textarea
                  id="formAdres"
                  name="adres"
                  rows="2"
                  className={`${inputClass} resize-none`}
                  value={formData.adres}
                  onChange={(e) => setFormData({ ...formData, adres: e.target.value })}
                  placeholder="Tam adres bilgisi"
                  disabled={isLoading}
                />
              </div>

              <div className="lg:col-span-2">
                <label htmlFor="formAciklama" className={labelClass}>Açıklama</label>
                <textarea
                  id="formAciklama"
                  name="aciklama"
                  rows="2"
                  className={`${inputClass} resize-none`}
                  value={formData.aciklama}
                  onChange={(e) => setFormData({ ...formData, aciklama: e.target.value })}
                  placeholder="Ek notlar"
                  disabled={isLoading}
                />
              </div>
            </div>

            {/* Ders Grupları */}
            <div className="mt-5 pt-4 border-t border-gray-200">
              <div className="flex items-baseline justify-between mb-2">
                <h4 className="text-sm font-medium text-gray-900">Ders Grupları</h4>
                <span className="text-xs text-gray-500">
                  {formData.ders.length} seçili
                </span>
              </div>

              {lessonGroups.length > 0 ? (
                <>
                  <div className="relative mb-2">
                    <svg className="w-4 h-4 absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                    <input
                      type="text"
                      className={`${inputClass} pl-8`}
                      placeholder="Ders ara…"
                      value={lessonSearchTerm}
                      onChange={(e) => setLessonSearchTerm(e.target.value)}
                      disabled={isLoading}
                    />
                  </div>

                  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-1.5 max-h-52 overflow-y-auto p-2 bg-gray-50 rounded-md border border-gray-200">
                    {filteredLessonGroups.length > 0 ? (
                      filteredLessonGroups.map(group => {
                        const checked = formData.ders.includes(group.id);
                        return (
                          <label
                            key={group.id}
                            className={`flex items-center gap-2 px-2 py-1.5 rounded cursor-pointer text-sm transition-colors ${
                              checked
                                ? 'bg-gray-900 text-white'
                                : 'bg-white border border-gray-200 text-gray-700 hover:border-gray-400'
                            } ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                          >
                            <input
                              type="checkbox"
                              checked={checked}
                              onChange={() => handleDersCheckboxChange(group.id)}
                              className="h-3.5 w-3.5 accent-gray-900"
                              disabled={isLoading}
                            />
                            <span className="truncate">{group.ders_adi}</span>
                          </label>
                        );
                      })
                    ) : (
                      <div className="col-span-full text-center py-4 text-sm text-gray-400">
                        "{lessonSearchTerm}" için sonuç yok
                      </div>
                    )}
                  </div>

                  {formData.ders.length > 0 && (
                    <button
                      type="button"
                      onClick={() => setFormData({ ...formData, ders: [] })}
                      className="mt-2 text-xs text-gray-500 hover:text-gray-900"
                      disabled={isLoading}
                    >
                      Tümünü kaldır
                    </button>
                  )}
                </>
              ) : (
                <div className="text-center py-4 text-sm text-gray-400 bg-gray-50 rounded-md border border-gray-200">
                  Ders grubu bulunamadı
                </div>
              )}
            </div>
          </form>
        </div>

        {/* Footer */}
        <div className="border-t border-gray-200 px-5 py-3 bg-gray-50/50">
          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={closeForm}
              disabled={isLoading}
              className="px-4 py-1.5 text-sm text-gray-700 bg-white border border-gray-200 rounded-md hover:bg-gray-50 transition-colors disabled:opacity-50"
            >
              İptal
            </button>
            <button
              type="submit"
              form="teacher-form"
              disabled={isLoading || !!passwordError}
              className={`px-4 py-1.5 text-sm font-medium text-white rounded-md transition-colors flex items-center gap-2 ${
                isLoading || passwordError ? 'bg-gray-300 cursor-not-allowed' : 'bg-gray-900 hover:bg-gray-800'
              }`}
            >
              {isLoading && (
                <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                </svg>
              )}
              {isLoading ? 'Kaydediliyor…' : currentTeacher ? 'Kaydet' : 'Ekle'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherFormModal;
